var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-popup",
    _vm._b(
      { on: { input: _vm.handlePopupInput } },
      "j-popup",
      _vm.popupProps,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }